<template>
  <div class="custom-select room-list-filter" v-click-outside="close">
    <div class="selected" :class="{ open: open, disabled: disabled }" @click="openSelect()">
      Rooms {{ selected.length }}/{{ rooms.length }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div class="session">
        <label class="styled-cb">
          <span class="filter-name">All rooms</span>
          <input id="select-all" type="checkbox" v-model="selectAll" @change="selectAllEvent()" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div v-for="room of rooms" :key="room.uuid" class="session">
        <label class="styled-cb">
          <span class="filter-name">{{ room.TITLE }} {{ room.uuid === activeRoom.uuid ? "(current)" : "" }}</span>
          <input :id="room.uuid" type="checkbox" :value="room.uuid" v-model="selected" />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RoomListCheckFilter",
  props: {
    disabled: {
      type: Boolean
    },
    value: {
      type: Array
    }
  },
  data() {
    return {
      selectAll: false,
      open: false
    };
  },
  computed: {
    ...mapGetters({
      rooms: "room/rooms",
      activeRoom: "room/activeRoom"
    }),
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    openSelect() {
      if (!this.disabled) {
        this.open = !this.open;
      }
    },
    close() {
      this.open = false;
    },
    selectAllEvent() {
      if (this.selectAll) {
        this.rooms.forEach(room => {
          this.selected.includes(room.uuid) ? null : this.selected.push(room.uuid);
        });
      } else {
        this.selected = [];
      }
    }
  },
  watch: {
    selected: function() {
      this.selectAll = this.selected.length === this.rooms.length;
    },
    disabled: function(val) {
      if (val) {
        this.open = false;
      }
    }
  }
};
</script>
